var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3672_367)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 30C31.5913 30 33.1174 29.3679 34.2426 28.2426C35.3679 27.1174 36 25.5913 36 24C36 22.4087 35.3679 20.8826 34.2426 19.7574C33.1174 18.6321 31.5913 18 30 18C28.4087 18 26.8826 18.6321 25.7574 19.7574C24.6321 20.8826 24 22.4087 24 24C24 25.5913 24.6321 27.1174 25.7574 28.2426C26.8826 29.3679 28.4087 30 30 30ZM27.8578 32.25C23.2406 32.25 19.5 35.9906 19.5 40.6078C19.5 41.3766 20.1234 42 20.8922 42H39.1078C39.8766 42 40.5 41.3766 40.5 40.6078C40.5 35.9906 36.7594 32.25 32.1422 32.25H27.8578Z",
    fill: "#222423"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3672_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24,
    fill: "white",
    transform: "translate(19.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabs);
export default __webpack_public_path__ + "static/media/tabs.17061b1eb515fed339027584325071f9.svg";
export { ForwardRef as ReactComponent };